import { createContext, useContext } from 'react'
import type { IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'
import type { OfferProperty } from 'BrokerTsLib/src/dtos'
import { insuranceParamsContext } from '../layouts/Wizard'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'

export const propertyOffersContext = createContext<IOffersContext<OfferProperty>>(defaults as any)

function PropertyOffersProvider({ children }: { children: React.ReactNode }) {
  const { insuranceParams, insuranceParamsId } = useContext(insuranceParamsContext) ?? {}

  if (!insuranceParamsId)
    return null

  return (
    <OffersProvider
      insuranceParamsId={insuranceParamsId}
      isContract={!!insuranceParams?.generalParams.contractNumber}
      signalRCalcFinishedEventName='PropertyCalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={propertyOffersContext as any}
    >
      {children}
    </OffersProvider >
  )
}

export default PropertyOffersProvider


export const usePropertyOffersContext = () => {
  const context = useContext(propertyOffersContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('usePropertyOffersContext must be used within a PropertyOffersProvider!')
  }

  return context
}